import React from 'react';
import { Icon } from '../../components';
import s from './HostStyles.module.scss';

const IconHost = () => (
    <div className={s.editor} style={{ padding: '100px' }}>
        <Icon iconId="eat" />
        <Icon iconId="aed" />
        <Icon iconId="restroom" />
    </div>
);

export default IconHost;
